import {
    GeneralInvestingGoal,
    getAnnualReturnUsingRiskScore,
} from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { BaseGoalConfig } from './types';

export const GENERAL_INVESTING: BaseGoalConfig<GeneralInvestingGoal> = {
    iconName: 'GoalInvesting',
    color: colorsByGoalType['GENERAL_INVESTING'].primary,
    title: 'Start investing',
    defaultName: 'General investing',
    getDescription: () => 'Time in the market beats timing the market.',
    group: 'INVEST',
    blogLink: null,
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: () => null,
};
